import { GridPostParams } from "common/models/utility-models/list-utility.model";

export class PlacementReportsGridPostParams extends GridPostParams {
    reportTypeFlag: number = 8;
    search_keyword: '';
    region_search: string = '';
    batch_search: any = '';
    branch_search: any = '';
    state_search: any = '';
    gender_search: string = ''
    status_search: any = '';
}